import { inject } from '@angular/core';
import { PRIMARY_OUTLET, RedirectFunction, Router, UrlTree } from '@angular/router';

/**
 * Permanent legacy redirect: `/hub/** → /**`. Previously-issued `/hub/...`
 * URLs persist outside the app (bookmarks, delivered notification rows,
 * emails), so this must never be removed. Rebuilds the full requested URL
 * without the leading `hub` segment, preserving query params, fragment and
 * secondary outlets. `/hub` alone redirects to `/`.
 */
export const legacyHubPrefixRedirect: RedirectFunction = (): UrlTree => {
  const router = inject(Router);
  const requested = router.getCurrentNavigation()?.extractedUrl ?? router.parseUrl('/');
  // Clone before mutating — `extractedUrl` is the router's own navigation state.
  const target = router.parseUrl(router.serializeUrl(requested));
  const primary = target.root.children[PRIMARY_OUTLET];
  if (primary?.segments[0]?.path === 'hub') {
    primary.segments = primary.segments.slice(1);
    if (primary.segments.length === 0 && Object.keys(primary.children).length === 0) {
      delete target.root.children[PRIMARY_OUTLET];
    }
  }
  return target;
};
